
import { useQuery} from '@tanstack/react-query';
import { useSettlementsApi } from '../../Hooks/useSettlementsAPI';


type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  storeId?: string;
  userId?: string;
  userType?: string;
  transactionType?: string;
  fromDate?: string;
  toDate?: string;
};

export const useGetSettlements = (queryParams: Params) => {
  console.log('useGetSettlements called with params:', queryParams);
  const { getAllSettlements } = useSettlementsApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: [
      'getSettlements',
     queryParams
    ],
    queryFn: () => {
      console.log('Query function executing with params:', queryParams);
      return getAllSettlements(queryParams);
    },
  });
  
  console.log('useGetSettlements result:', { data, isFetching, isRefetching });


  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};


